import React, { useMemo } from 'react'
import style from './style.module.scss'
import clsx from 'clsx'
import Breadcrumb, { BreadcrumbItemProps } from '../../components/Breadcrumb'

type ContentPageHeaderProps = {
    title: string
    subTitle: string
    breadcrumb: BreadcrumbItemProps[]
}

const ContentPageHeader: React.FC<ContentPageHeaderProps> = ({ title, subTitle, breadcrumb }) => {
    const links = useMemo(() => {
        const home: BreadcrumbItemProps = {
            url: '/',
            label: 'Accueil',
        }

        return [home, ...breadcrumb]
    }, [breadcrumb])

    return (
        <div className={style.content}>
            {subTitle && <div className={style.subTitle}>{subTitle}</div>}
            <h1 className={clsx(style.title, !subTitle ? style.margin : undefined)}>{title}</h1>
            <Breadcrumb links={links} />
        </div>
    )
}

export default ContentPageHeader
